import router from "src/http/router";
import vuex from "src/vuex"

export default {
  name: "errors",
  error({ config, request, response }) {
    let payload = {};
    if (response && response.data) {
      payload = response.data;
    }
    if (payload !== {} && config.vueRoute.path === router.currentRoute.path) {
      vuex.dispatch("parseErrorResponse", payload);
      vuex.dispatch("finishLoadingWithError");
    }

    return {
      resource: config.model,
      request: config,
      response,
      payload
    };
  }
};
